import React from 'react';
import { bool, func, string } from 'prop-types';

import './price-error.scss';

// eslint-disable-next-line react/prop-types
const DefaultErrorMessage = ({ onRefresh }) => {
  return (
    <div>
      We&apos;re sorry, something went wrong on our end. <br />
      Please try&nbsp;
      <button
        className="link"
        type="button"
        data-testid="reload-div"
        onClick={onRefresh}
      >
        refreshing.
      </button>
    </div>
  );
};

export const PriceError = ({ refresh, setRefresh, message }) => {
  return (
    <div className="rental-error">
      <img
        alt=""
        src="https://assets.homedepot-static.com/images/v1/alert-warning-yellow.svg"
        height="23px"
        width="23px"
      />
      {message || (<DefaultErrorMessage onRefresh={() => setRefresh(!refresh)} />)}
    </div>
  );
};

PriceError.displayName = 'PriceError';

PriceError.propTypes = {
  refresh: bool.isRequired,
  setRefresh: func.isRequired,
  message: string
};

PriceError.defaultProps = {
  message: ''
};